import { villageConstants } from '../_constants';
import { villageService } from '../_services';
import { error as toastError} from 'react-toastify-redux';
import { history } from '../_helpers';

export const villageActions = {
    getAll,
    createNew,
    update,
    delete: _delete
  };


function getAll() {
    return dispatch => {

        dispatch(request());
        console.log("REQUESTED")
        villageService.getAll()
            .then(
                villages => {
                    console.log("THEN SUCCESS");
                    dispatch(success(villages))
                }
            ).catch(
                error => {
                    console.log("THEN ERROR");
                    dispatch(failure(error.error));
                    //dispatch(toastError(error));
            });
    };

    function request() { return { type: villageConstants.GETALL_REQUEST } }
    function success(villages) { return { type: villageConstants.GETALL_SUCCESS, villages } }
    function failure(error) { return { type: villageConstants.GETALL_FAILURE, error } }
}

function createNew(village)  {
    return dispatch => {
        dispatch(request(village));

        villageService.create(village)
            .then(
                village => {
                    dispatch(success(village.data));
                },
                error => {
                    dispatch(failure(error));
                    //dispatch(toastError(error));
                }
            );
    };

    function request(id) { return { type: villageConstants.CREATE_REQUEST, village } }
    function success(id) { return { type: villageConstants.CREATE_SUCCESS, id } }
    function failure(id, error) { return { type: villageConstants.CREATE_FAILURE, id, error } }
}

function update(edit)  {
    return dispatch => {
        dispatch(request(edit));

        return villageService.update(edit)
            .then(
                village => {
                    dispatch(success(village));
                    return village;
                },
                error => {
                    dispatch(failure(error));
                    //dispatch(toastError(error));
                    return error;
                }
            );
    };

    function request(id) { return { type: villageConstants.UPDATE_REQUEST, edit } }
    function success(id) { return { type: villageConstants.UPDATE_SUCCESS, id } }
    function failure(id, error) { return { type: villageConstants.UPDATE_FAILURE, id, error } }
}

function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        villageService.delete(id)
            .then(
                user => {
                    dispatch(success(id));
                },
                error => {
                    dispatch(failure(id, error));
                }
            );
    };

    function request(id) { return { type: villageConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: villageConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: villageConstants.DELETE_FAILURE, id, error } }
}
